import { LanguageSaga, SentryService } from '@web_opxp/features';
import { all, call, spawn } from 'redux-saga/effects';
import { SharedErrors } from 'web_core_library';
import { AppSaga } from '../app';

export function* handleErrorSaga(error: Error | SharedErrors.BaseError) {
  yield call(console.error, error.message);
  yield call(SentryService.captureException, error);
}

export default function* rootSaga() {
  const sagas = [LanguageSaga, AppSaga];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
          } catch (error) {
            yield call(handleErrorSaga, error as Error | SharedErrors.BaseError);
          }
        }
      })
    )
  );
}
